export default {
  modalTitle: 'What is consultation mode?',
  modalText: 'You do not have permission to modify or update this user\'s information. The "consultation" mode only allows you to simulate the interface view on the "customer" side to see the products and services reserved for this user and you do not have the rights to modify or update this information.',
  headerText: 'Consultation mode enabled. ',
  modalLink: 'Read more',
};
